module.exports = __webpack_public_path__ + "static/media/close.a715bb1e.svg";